import { nextTick, watch } from 'vue'
import { createI18n, type Locale } from 'vue-i18n'
import { useAppContext } from '@/stores/appContext'
import { HttpClient } from '@vantis/shared'
import axios from 'axios'
//export const supportLocales = ['en-US', 'zh-cn']

let initialized = false
export const createDefaultI18n = async () => {
  if (initialized) {
    return
  }
  initialized = true
  const appContext = useAppContext();
  const i18nOptions = {
    legacy: false,
    locale: appContext.locale,
    messages: {},
    fallbackLocale: 'zh-cn',
    globalInjection: true,
    missingWarn: false,
    fallbackWarn: false
  };
  if (import.meta.env.VITE_LOCALE_MISS=="1") {
    (i18nOptions as any).missing = (locale: Locale, key: string) => {
      const httpClient=new HttpClient(axios);
      httpClient.get("https://localhost:7004/api/EnsureLocalization/Insert?key=" + key);
    }
  }

  const i18n = createI18n(i18nOptions);
  watch(() => appContext.locale, async () => {
    await setI18nLanguage(i18n, appContext.locale)
  },{immediate:true})
  return i18n
}

const setI18nLanguage = async (i18n: any, locale: string) => {
  locale = locale.toLowerCase();
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  if (!i18n.global.availableLocales.includes(locale)) {
    await loadLocaleMessages(i18n, locale)
  }
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */

}
const  messageModules=import.meta.glob('./app/*.mjs');
export async function loadLocaleMessages(i18n: any, locale: string) {
  try {
    // load locale messages with dynamic import
    const importMethod=messageModules[`./app/${locale}.mjs`];
    if(!importMethod) {
      return;
    }
    const messageModule:any=await importMethod();
    const messages = messageModule.default;
    // set locale and locale message
    i18n.global.setLocaleMessage(locale, messages)

    return nextTick()
  } catch (error: any) {
    if (import.meta.env.DEV) {
      i18n.global.setLocaleMessage(locale, {});
    }
    console.error(error)
  }
}